import { motion } from "framer-motion";
import { IMAGES, fadeIn } from "@/lib/numa-assets";

export const Philosophy = () => {
  const PRINCIPLES = [
    {
      n: "I",
      title: "Transparency",
      body: "Every dose is disclosed. Every batch is third-party tested. What is in the bottle is exactly what is on the label — nothing hidden, nothing implied.",
    },
    {
      n: "II",
      title: "Intention",
      body: "Every ingredient is dosed to a level supported by peer-reviewed human or translational research. Each active is selected for a specific mechanism — no filler, no marketing weight, no proprietary blends.",
    },
    {
      n: "III",
      title: "Access",
      body: "Longevity should not be gatekept. NUMA is engineered as a protocol anyone can enter — clinically grounded, plainly explained, quietly available.",
    },
  ];

  return (
    <section
      id="philosophy"
      data-testid="philosophy-section"
      className="relative border-t border-[#E2E5E0] py-24 sm:py-32 overflow-hidden bg-[#152219] text-[#F0F2EF]"
    >
      {/* Background image with matte overlay */}
      <div className="absolute inset-0">
        <img
          src={IMAGES.clinical_environment}
          alt=""
          aria-hidden="true"
          className="w-full h-full object-cover opacity-30"
        />
        <div className="absolute inset-0 bg-[#0E1714]/70" />
      </div>

      <div className="relative max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        <motion.div {...fadeIn} className="max-w-3xl">
          <div className="flex items-center gap-4 mb-8">
            <span
              className="text-[11px] tracking-[0.28em] uppercase"
              style={{ color: "#8A9A90" }}
            >
              06
            </span>
            <span className="h-[1px] w-12 bg-[#8A9A90]" />
            <span
              className="text-[11px] tracking-[0.28em] uppercase"
              style={{ color: "#D6E1D9" }}
            >
              Mission
            </span>
          </div>
          <h2
            className="font-heading text-4xl sm:text-5xl lg:text-6xl tracking-[-0.025em] font-medium leading-[1.04]"
            data-testid="philosophy-title"
          >
            Principles
            <br />
            of longevity.
          </h2>
          <p className="text-[15px] leading-[1.8] text-[#C3D1C9] mt-8 max-w-xl">
            NUMA is built on the belief that healthy aging comes from
            consistent, evidence-based support. Every product is designed
            around three principles: honest disclosure, precise intention,
            and open access to the science that guides it.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-px bg-[#2A3A31] mt-20 border border-[#2A3A31]">
          {PRINCIPLES.map((p, i) => (
            <motion.div
              key={p.n}
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{
                duration: 0.8,
                delay: i * 0.08,
                ease: [0.16, 1, 0.3, 1],
              }}
              className="bg-[#152219] p-10 lg:p-12"
              data-testid={`principle-${p.n.toLowerCase()}`}
            >
              <span
                className="font-heading text-base"
                style={{ color: "#8AA493" }}
              >
                {p.n}
              </span>
              <h3 className="font-heading text-2xl tracking-tight mt-6 text-[#F0F2EF]">
                {p.title}
              </h3>
              <p className="text-[14px] leading-[1.7] text-[#C3D1C9] mt-4">
                {p.body}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Philosophy;
